export default {
  channels: 'CHAT_CHANNELS',
  channelInfo: 'CHAT_CHANNEL_INFO',
  messages: 'CHAT_MESSAGES',
  sendMessage: 'CHAT_SEND_MESSAGE',
  markAsRead: 'CHAT_MARK_AS_READ',
  editMessage: 'CHAT_EDIT_MESSAGE',
  deleteMessage: 'CHAT_DELETE_MESSAGE',
  searchMessages: 'CHAT_SEARCH_MESSAGES',
  clearSearch: 'CHAT_CLEAR_SEARCH',
  newMessageReceived: 'CHAT_NEW_MESSAGE_RECEIVED',
  messageReadReceived: 'CHAT_MESSAGE_READ_RECEIVED',
  messageEditedReceived: 'CHAT_MESSAGE_EDITED_RECEIVED',
  messageDeletedReceived: 'CHAT_MESSAGE_DELETED_RECEIVED',
};
